import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

const template = `
    <div class="alert-wrapper">
        <div id="AlertContainer" class="alert-container">
        </div>
    </div>
`;

export type AlertContainerOptions = ComponentOptions;

export class AlertContainer extends TemplateComponent {

    options: AlertContainerOptions;

    constructor(options?: AlertContainerOptions) {
        super(template, options || {});
    }

}
